(() => {
  function initHeaderMenuToggle() {
    document.querySelectorAll('.header').forEach((header) => {
      const drawerDetails = header.querySelector('header-drawer details');
      const menu = header.querySelector('.header__inline-menu');

      if (!drawerDetails || !menu || header.dataset.menuToggleReady) return;
      header.dataset.menuToggleReady = 'true';

      const dropdowns = menu.querySelectorAll('details');

      function closeDropdowns() {
        dropdowns.forEach((item) => item.removeAttribute('open'));
      }

      function closeMenu() {
        drawerDetails.removeAttribute('open');
        menu.classList.remove('active');
        header.classList.remove('drawer-active');
        closeDropdowns();
      }

      function syncMenu() {
        const isOpen = drawerDetails.open;

        menu.classList.toggle('active', isOpen);
        header.classList.toggle('drawer-active', isOpen);

        if (!isOpen) closeDropdowns();
      }

      drawerDetails.addEventListener('toggle', syncMenu);

      dropdowns.forEach((item) => {
        const summary = item.querySelector('summary');

        if (!summary) return;

        summary.addEventListener('click', () => {
          setTimeout(() => {
            dropdowns.forEach((otherItem) => {
              if (otherItem !== item) otherItem.removeAttribute('open');
            });
          }, 10);
        });
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          setTimeout(closeMenu, 150);
        });
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          closeMenu();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu();
        }
      });

      syncMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMenuToggle);
  } else {
    initHeaderMenuToggle();
  }

  document.addEventListener('shopify:section:load', initHeaderMenuToggle);
})();

   /*
      * The spacer prevents the page content from jumping
      * when the header changes to position: fixed.
    */
  (() => {
  "use strict";

  const DESKTOP_BREAKPOINT = 990;
  let stickyHeaderController = null;

  class DesktopStickyHeader {
    constructor(header) {
      this.header = header;
      this.spacer = null;
      this.originalTop = 0;
      this.headerHeight = 0;
      this.animationFrame = null;
      this.resizeTimer = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.createSpacer();
      this.measure();

      window.addEventListener("scroll", this.handleScroll, {
        passive: true
      });

      window.addEventListener("resize", this.handleResize);
    }

    createSpacer() {
      let spacer = this.header.nextElementSibling;

      if (
        !spacer ||
        !spacer.classList.contains("header-sticky-spacer")
      ) {
        spacer = document.createElement("div");
        spacer.className = "header-sticky-spacer";
        spacer.setAttribute("aria-hidden", "true");

        this.header.insertAdjacentElement("afterend", spacer);
      }

      this.spacer = spacer;
    }

    reset() {
      this.header.classList.remove("header-sticky-active");
      this.spacer.classList.remove("is-active");
      this.spacer.style.height = "0px";
    }

    measure() {
      /*
       * Remove fixed positioning before measuring
       * the header's original position.
       */
      this.reset();

      const headerRect = this.header.getBoundingClientRect();

      this.originalTop = Math.round(
        headerRect.top + window.scrollY
      );

      this.headerHeight = Math.ceil(
        this.header.offsetHeight
      );

      this.update();
    }

    update() {
      /*
       * Desktop only.
       */
      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        this.reset();
        return;
      }

      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        0;

      const shouldBeSticky =
        scrollTop > this.originalTop;

      this.header.classList.toggle(
        "header-sticky-active",
        shouldBeSticky
      );

      this.spacer.classList.toggle(
        "is-active",
        shouldBeSticky
      );

      this.spacer.style.height = shouldBeSticky
        ? `${this.headerHeight}px`
        : "0px";
    }

    handleScroll() {
      if (this.animationFrame !== null) {
        return;
      }

      this.animationFrame = window.requestAnimationFrame(() => {
        this.update();
        this.animationFrame = null;
      });
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);

      this.resizeTimer = window.setTimeout(() => {
        this.measure();
      }, 150);
    }

    destroy() {
      window.removeEventListener(
        "scroll",
        this.handleScroll
      );

      window.removeEventListener(
        "resize",
        this.handleResize
      );

      if (this.animationFrame !== null) {
        window.cancelAnimationFrame(
          this.animationFrame
        );
      }

      this.reset();

      if (this.spacer) {
        this.spacer.remove();
      }
    }
  }

  function initializeDesktopStickyHeader() {
    const header = document.querySelector(
      ".header-wrapper"
    );

    if (!header) {
      console.warn(
        "Sticky header: .header-wrapper was not found."
      );

      return;
    }

    /*
     * Do not initialize the same header twice.
     */
    if (
      stickyHeaderController &&
      stickyHeaderController.header === header
    ) {
      stickyHeaderController.measure();
      return;
    }

    if (stickyHeaderController) {
      stickyHeaderController.destroy();
    }

    stickyHeaderController =
      new DesktopStickyHeader(header);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeDesktopStickyHeader
    );
  } else {
    initializeDesktopStickyHeader();
  }

  /*
   * Reinitialize when Shopify reloads the header
   * in the theme customizer.
   */
  document.addEventListener(
    "shopify:section:load",
    () => {
      window.setTimeout(
        initializeDesktopStickyHeader,
        100
      );
    }
  );
})();
